import { GetStaticProps, NextPage } from 'next';

import HelpPage from '@/views/help-page';

const Help: NextPage = () => {
  return <HelpPage />;
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      namespaces: ['shared'],
    },
  };
};

export default Help;
